import ImmersiveReaderProcessTextResponse from 'owa-service/lib/contract/ImmersiveReaderProcessTextResponse';
import immersiveReaderProcessTextOperation from 'owa-service/lib/operation/immersiveReaderProcessTextOperation';
import ItemId from 'owa-service/lib/contract/ItemId';
import RequestOptions from 'owa-service/lib/RequestOptions';

export default function immersiveReaderProcessText(
    itemId: ItemId,
    sessionId: string,
    version: string,
    requestOptions: RequestOptions
): Promise<ImmersiveReaderProcessTextResponse> {
    return immersiveReaderProcessTextOperation(
        {
            itemId: itemId,
            sessionId: sessionId,
            version: version,
        },
        requestOptions
    );
}
